import { type ConsentChoice, persistConsentChoice, readConsentChoice } from '@repo/analytics/src/consent';
import { isAnalyticsEnabled, setAnalyticsConsent } from '@repo/analytics/src/ga';
import { useEffect, useState } from 'react';

import styles from './ConsentBanner.module.scss';

const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only prompt when there's no saved choice; init already applied an existing
    // one as the consent default. setTimeout defers setState (react-hooks warning).
    setTimeout(() => {
      if (isAnalyticsEnabled() && readConsentChoice() === null) setVisible(true);
    }, 0);
  }, []);

  const decide = (choice: ConsentChoice) => {
    persistConsentChoice(choice);
    setAnalyticsConsent(choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="dialog" aria-label="Cookie consent">
      <div className={styles.text}>
        We use cookies to improve the dashboard and see what&apos;s working for you. Accept to help us make it better.
      </div>
      <div className={styles.actions}>
        <button type="button" className="btn btn-primary fw-semibold px-4" onClick={() => decide('granted')}>
          Accept
        </button>
        <button
          type="button"
          className="btn btn-sm btn-link text-muted text-decoration-none"
          onClick={() => decide('denied')}
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default ConsentBanner;
